import { useQuery } from '@tanstack/react-query';
import { type SavedViewsListResult, listSavedViews } from '../lib/saved-views-client.js';

export const savedViewsQueryKey = (tenantReportId: string) =>
  ['saved-views', tenantReportId] as const;

export function useSavedViews(tenantReportId: string) {
  return useQuery<SavedViewsListResult, Error>({
    queryKey: savedViewsQueryKey(tenantReportId),
    queryFn: () => listSavedViews(tenantReportId),
    staleTime: 30_000,
    enabled: tenantReportId.length > 0,
  });
}
